import type React from "react";
import { cn } from "../utils/cn";

interface CaseStudiesIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function CaseStudiesIcon({ className, title = "Case Studies Icon", dark, ...props }: CaseStudiesIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Case Studies Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17 12.3262V3.5C17 3.22386 16.7761 3 16.5 3H3.5C3.22386 3 3 3.22386 3 3.5V16.5C3 16.7417 3.17145 16.9437 3.39941 16.9902L3.5 17H11.4579V11.9579H16.9999V12.3271L17 12.3262ZM16.4275 13.0419L12.5419 16.3299V13.0419H16.4275ZM16.5 1.59961C17.5493 1.59961 18.4004 2.45066 18.4004 3.5V12.3262C18.4003 12.8149 18.2116 13.2819 17.8789 13.6328L17.7275 13.7764L12.7939 17.9502C12.4509 18.2405 12.0158 18.4004 11.5664 18.4004H3.5C2.45066 18.4004 1.59961 17.5493 1.59961 16.5V3.5C1.59961 2.45066 2.45066 1.59961 3.5 1.59961H16.5ZM13.9999 6.49988V5.20007H4.99988V6.49988H13.9999ZM13.9999 7.70007V8.99988H4.99988V7.70007H13.9999ZM7.76941 11.4999V10.2001H4.99988V11.4999H7.76941Z"
        fill={dark ? "white" : "black"}
      />
    </svg>
  );
}

export default CaseStudiesIcon;
